// src/components/Home.js
import React, { useState, useEffect } from "react";
import MyNavbar from "../components/MyNavbar";
import Imgprofile from "../assets/images/Profile.png";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";

export default function Home() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch posts from Firestore
        const fetchPosts = async () => {
            try {
                const q = query(collection(db, "posts"), orderBy("timestamp", "desc"), limit(10));
                const querySnapshot = await getDocs(q);
                const fetchedPosts = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setPosts(fetchedPosts);
            } catch (err) {
                setError("Failed to load posts");
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    if (loading) {
        return <div>Loading posts...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <>
            <MyNavbar />
            <div className="container pt-5">
                <div className="row justify-content-center">
                    {posts.map((post) => (
                        <div key={post.id} className="col-12 col-md-10 col-lg-8 card shadow-sm mb-4">
                            <div className="d-flex justify-content-between p-3">
                                <div className="d-flex">
                                    <img
                                        src={Imgprofile} // Placeholder image, you can replace this with user profile picture from Firebase Storage if needed
                                        alt="Profile"
                                        className="rounded-circle me-3"
                                        style={{ width: "60px", height: "60px" }}
                                    />
                                    <div>
                                        <h5 className="mb-0">{post.username}</h5>
                                        <small className="text-secondary">{new Date(post.timestamp.seconds * 1000).toLocaleString()}</small>
                                    </div>
                                </div>
                                <div>
                                    <button className="btn btn-light btn-sm">Options</button>
                                </div>
                            </div>
                            <hr />
                            <div className="px-3">
                                <p className="mb-0">
                                    {post.content}
                                    <button className="btn btn-link p-0 ms-1">
                                        Read More
                                    </button>
                                </p>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-around px-5 pb-3">
                                <button className="btn btn-sm">
                                    <i className="fa-regular fa-heart"></i> Like
                                </button>
                                <button className="btn btn-sm">
                                    <i className="bi bi-chat"></i> Comment
                                </button>
                                <button className="btn btn-sm">
                                    <i className="bi bi-bookmark"></i> Save
                                </button>
                                <button className="btn btn-sm">
                                    <i className="bi bi-share"></i> Share
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
